import { createSplashScreen } from "./createSplashScreen"
import { fire } from "../utils/events";
import resize from "../utils/resize";

const Splash = new class Splash {
    constructor() {
        this.isRemoved = false;
        this.el = null;
        this.container = null;
    }

    pop(elId, cb) {

        this.container = document.getElementById(elId);

        this.el = this.el || document.getElementById("splash");

        if (!this.el) {
            this.el = createSplashScreen();
            this.container.appendChild(this.el);
        } else {
            this.el.progressValue = document.getElementById("progressText");
        }
        setTimeout(cb, 0);

    }

    setProgressText(text) {
        this.el.progressValue.innerText = text;
    }

    update(r) {
        const s = this.el.progressStart || 0;

        this.el.progress.style.width = parseInt((s + r * (1 - s)) * 120) + "px";

    }

    removeProgress() { }

    remove() {
        if (!this.isRemoved) {
            document.body.style.removeProperty("background");
            document.body.style.removeProperty("background-color");
            setTimeout(() => {
                this.container.removeChild(this.el);
                Q3.container.classList.remove("loading");
                resize();
                fire("splashremoved");
                if (Q3.inPreviewMode) {
                    parent.postMessage({ type: "previewReady" }, '*');
                }
            }, 500);
        }

        this.isRemoved = true;
    }
}

export default Splash;
export { Splash };